var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tab-layout",
    {
      attrs: {
        buttons: _vm.more.buttons,
        parameters: _vm.parameters,
        permissions: _vm.permissions
      }
    },
    [
      _c("template", { slot: "title" }, [
        _vm._v(
          "\n        " + _vm._s(_vm.$l10n.__("Contacts associés")) + "\n    "
        )
      ]),
      _vm._v(" "),
      _c("template", { slot: "content" }, [
        _c("div", { staticClass: "ovy-auto" }, [
          _vm.mainContact.length > 0
            ? _c(
                "section",
                { staticClass: "mb-3" },
                [
                  _vm.mainContact[0].billingContact == true
                    ? _c("h4", { staticClass: "mt-0" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$l10n.__(
                                "Contact principal et de facturation"
                              )
                            ) +
                            "\n                "
                        )
                      ])
                    : _c("h4", { staticClass: "mt-0" }, [
                        _vm._v(_vm._s(_vm.$l10n.__("Contact principal")))
                      ]),
                  _vm._v(" "),
                  _vm._l(_vm.mainContact, function(contact) {
                    return _c(
                      "div",
                      { key: contact.id, staticClass: "well mb-2" },
                      [
                        _c(
                          "person-card" +
                            (!!contact.sellsyadmin ? "-sellsyadmin" : ""),
                          {
                            tag: "component",
                            attrs: {
                              person: contact,
                              permissions: _vm.permissions
                            },
                            on: { clicked: _vm.switchAction }
                          }
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.billingContact.length > 0
            ? _c(
                "section",
                { staticClass: "mb-3" },
                [
                  _c("h4", { staticClass: "mt-0" }, [
                    _vm._v(_vm._s(_vm.$l10n.__("Contact de facturation")))
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.billingContact, function(contact) {
                    return _c(
                      "div",
                      { key: contact.id, staticClass: "well mb-2" },
                      [
                        _c(
                          "person-card" +
                            (!!contact.sellsyadmin ? "-sellsyadmin" : ""),
                          {
                            tag: "person-card",
                            attrs: {
                              person: contact,
                              permissions: _vm.permissions
                            },
                            on: { clicked: _vm.switchAction }
                          }
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "prelative" },
            [
              _c("preloader", {
                staticClass: "mt-3",
                attrs: { display: _vm.loading }
              }),
              _vm._v(" "),
              !_vm.loading &&
              (_vm.otherContacts.length > 0 || _vm.archivedContacts.length > 0)
                ? _c("div", [
                    _c("h4", { staticClass: "mt-0" }, [
                      _vm._v(_vm._s(_vm.$l10n.__("Autres contacts")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex-column flex" }, [
                      _c("section", { staticClass: "mb-3" }, [
                        _c(
                          "div",
                          [
                            _vm._l(_vm.otherContacts, function(contact) {
                              return _c(
                                "div",
                                { key: contact.id, staticClass: "well mb-2" },
                                [
                                  _c(
                                    "person-card" +
                                      (!!contact.sellsyadmin
                                        ? "-sellsyadmin"
                                        : ""),
                                    {
                                      tag: "component",
                                      attrs: {
                                        person: contact,
                                        permissions: _vm.permissions
                                      },
                                      on: { clicked: _vm.switchAction }
                                    }
                                  )
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _vm.archivedContacts.length > 0
                              ? _c(
                                  "section",
                                  [
                                    _c("h4", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$l10n.__("Contacts archivés")
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(_vm.archivedContacts, function(
                                      contact
                                    ) {
                                      return _c("person-card", {
                                        key: contact.id,
                                        staticClass: "well mb-3 gray-60",
                                        attrs: {
                                          person: contact,
                                          permissions: _vm.permissions
                                        },
                                        on: { clicked: _vm.switchAction }
                                      })
                                    })
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.infiniteLoading
                              ? _c("CompassButton", {
                                  attrs: {
                                    label: _vm.$t.__(
                                      "common.actions.load_more"
                                    ),
                                    loading: _vm.loading
                                  },
                                  on: { click: _vm.fetch }
                                })
                              : _vm._e()
                          ],
                          2
                        )
                      ])
                    ])
                  ])
                : _c("div", [
                    !_vm.loading && _vm.contacts.length == 0
                      ? _c("div", { staticClass: "placeholder" }, [
                          _c("p", [_vm._v(_vm._s(_vm.placeholder))])
                        ])
                      : _vm._e()
                  ])
            ],
            1
          )
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }